module.exports = __webpack_public_path__ + "static/img/logo.0095ce0b.png";